import { defaultLocale, localeToLanguageTag, type Locale } from "@/lib/i18n";

export function formatDate(date: string, locale: Locale = defaultLocale) {
  return new Intl.DateTimeFormat(localeToLanguageTag(locale), {
    weekday: "long",
    day: "2-digit",
    month: "long",
    // Schedule dates are calendar dates, not instants. Formatting in UTC keeps
    // date-only values such as `2026-11-28` identical on the server and client.
    timeZone: "UTC",
  }).format(new Date(date));
}
